import React from 'react';

import { SchedulerEditor } from 'components/Scheduler';

import './scheduler-editor-page.scss';

const SchedulerEditorPage = () => (
  <div className="container container--scheduler-editor">
    <section className="page-title">
      <h1 className="title">Scheduling Assistant</h1>
    </section>
    <SchedulerEditor />
  </div>
);

export default SchedulerEditorPage;
